import { render } from "./PostEmail.vue?vue&type=template&id=ff8b92f0&scoped=true"
import script from "./PostEmail.vue?vue&type=script&lang=js"
export * from "./PostEmail.vue?vue&type=script&lang=js"

import "./PostEmail.vue?vue&type=style&index=0&id=ff8b92f0&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8b92f0"]])

export default __exports__